import { render, staticRenderFns } from "./two_header.vue?vue&type=template&id=48b92377&scoped=true"
import script from "./two_header.vue?vue&type=script&lang=js"
export * from "./two_header.vue?vue&type=script&lang=js"
import style0 from "./two_header.vue?vue&type=style&index=0&id=48b92377&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b92377",
  null
  
)

export default component.exports